import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ig-layout-header-icon',
    templateUrl: './layout-header-icon.component.html',
    styleUrls: ['./layout-header-icon.component.scss'],
    standalone: false
})
export class LayoutHeaderIconComponent {
  /**
   * show a badge into the icon area
   */
  @Input() showBadge = false;
  /**
   * show dot in badge instead a number (=unknown number)
   */
  @Input() showBadgeAsDot = false;
  /**
   * color of the badge
   */
  @Input() badgeColor: 'green' | 'red' | 'orange' = 'green';
  /**
   * number to display in the badge
   */
  @Input() badgeCount = 0;
  /**
   * controls animation stuff
   */
  @Input() badgeWasVisible = false
  /**
   * class of the icon to display
   */
  @Input() iconCls?: string;
  /**
   * shows the arrow below the icon pointing to the open menu
   */
  @Input() isMenuOpen = false;

  @Input() ariaLabel = '';

  @Output() onClick = new EventEmitter<void>();

  myOnClick(e: Event) {
    e.preventDefault();
    this.onClick.emit();
  }
}
